export default "__VITE_ASSET__BGZALaGK__"